import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Newspaper } from 'lucide-react'; // Added Newspaper icon
import ThemeToggle from './ThemeToggle';
import { tools } from '../lib/tools'; // Import the shared tools list
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from '../components/ui/sheet';

function Navbar() {
  const location = useLocation();
  
  return (
    <nav className="bg-card border-b border-border backdrop-blur-lg bg-opacity-80 sticky top-0 z-50 md:hidden">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center space-x-2 group"
            aria-label="Go to tools menu"
          >
            <span className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
              Tools Menu
            </span>
          </Link>
          
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Sheet>
              <SheetTrigger asChild>
                <button
                  className="p-2 text-muted-foreground hover:text-foreground transition-colors"
                  aria-label="Open menu"
                >
                  <Menu className="h-6 w-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="left" className="bg-card border-r border-border w-64">
                <div className="container mx-auto px-4 py-3 space-y-1">
                  {/* Add Blog link first */}
                  <SheetClose asChild>
                    <Link
                      key="/blog"
                      to="/blog"
                      className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                        location.pathname.startsWith('/blog') // Highlight if on blog index or post
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                      }`}
                      aria-current={location.pathname.startsWith('/blog') ? 'page' : undefined}
                    >
                      <Newspaper className="h-5 w-5 mr-3" />
                      <span className="font-medium">Blog</span>
                    </Link>
                  </SheetClose>
                  {/* Then map other tools */}
                  {tools.map(({ path, icon: Icon, label }) => ( // Use imported 'tools' array
                    <SheetClose asChild key={path}>
                      <Link
                        to={path}
                        className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                          location.pathname === path
                          ? 'bg-primary text-primary-foreground'
                          : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                        }`}
                        aria-current={location.pathname === path ? 'page' : undefined}
                      >
                        <Icon className="h-5 w-5 mr-3" />
                        <span className="font-medium">{label}</span>
                      </Link>
                    </SheetClose>
                  ))}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;